import { buildCreateSlice, PayloadAction } from '@reduxjs/toolkit';
import { StaticImageData } from 'next/image';

import { CategoriesModalStateType } from '../types/categoriesModalState';

const createAppSlice = buildCreateSlice();

const initialState: CategoriesModalStateType = {
  open: false,
  activeValue: null,
  activeImage: null
};

export const categoriesModalSlice = createAppSlice({
  name: 'categoriesModal',
  initialState,
  reducers: (create) => ({
    openCategoriesModal: create.reducer((state) => {
      state.open = true;
    }),
    closeCategoriesModal: create.reducer((state) => {
      state.open = false;
    }),
    changeActiveValue: create.reducer((state, action: PayloadAction<string | null>) => {
      state.activeValue = action.payload;
    }),
    changeActiveImage: create.reducer((state, action: PayloadAction<StaticImageData>) => {
      state.activeImage = action.payload;
    })
  })
});

export const { openCategoriesModal, closeCategoriesModal, changeActiveValue, changeActiveImage } =
  categoriesModalSlice.actions;

export const categoriesModalReducer = categoriesModalSlice.reducer;
